import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import { ApiHandlerProvider } from './util/apiHandler';
import root from './router/root';
import AppQueryProvider from './provider/AppQueryProvider'; 
import avatarCacheManager from './util/avatarCacheManager'; 

export default function App() {
  const queryClientOptions = {
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000,  // 5분
      },
    },
  };

  // 아바타 캐시 초기화 (완전히 한 번만 실행)
  useEffect(() => {
    const initializeAvatarCache = async () => {
      // localStorage에 마이그레이션 완료 플래그 확인
      const migrationFlag = localStorage.getItem('avatarMigrationCompleted');
      if (migrationFlag === 'true') {
        return;
      }

      try {
        // localStorage에서 IndexedDB로 기존 아바타 데이터 마이그레이션
        await avatarCacheManager.migrateFromLocalStorage();
        
        // 마이그레이션 완료 플래그 설정
        localStorage.setItem('avatarMigrationCompleted', 'true');
      } catch (error) {
        // console.error('아바타 캐시 초기화 실패:', error);
        // 실패해도 플래그는 설정하지 않아서 다음에 다시 시도 가능
      }
    };

    initializeAvatarCache();
  }, []); // 의존성 배열은 빈 배열 유지

  return (
    <AppQueryProvider queryClientOptions={queryClientOptions}>
      <ToastProvider>
        <ApiHandlerProvider>
          <RouterProvider future={{ v7_startTransition: true }} router={root} />
        </ApiHandlerProvider>
      </ToastProvider>
    </AppQueryProvider>
  );
}